<template>
  <TransitionRoot appear :show="qrcreate.modal_embed" as="template">
    <Dialog
      as="div"
      @close="qrcreate.modal_embed = false"
      class="relative z-10"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white px-4 pb-4 pt-2 text-left align-middle shadow-xl transition-all"
            >
              <DialogTitle>
                <div class="flex items-center">
                  <button
                    @click="qrcreate.modal_embed = false"
                    class="flex items-center justify-center p-2"
                  >
                    <XIcon />
                  </button>
                </div>
              </DialogTitle>
              <div class="flex flex-col gap-y-4">
                <div class="flex items-center justify-center w-full">
                  <h3 class="text-lg text-center font-medium leading-6 text-gray-900">
                    Embed QR code on your website
                  </h3>
                </div>
                <p class="text-center">
                  To embed the QR code on your website, use the following HTML
                  code. Commercial usage is allowed.
                </p>
                <textarea :value="html"
                  class="w-full rounded-md text-base text-gray-900 p-2 bg-white border border-gray-200 focus:border-success focus:outline-none focus:ring-0" rows="6"
                ></textarea>
              </div>
              <div class="mt-6 flex justify-end">
                <button @click="qrcreate.modal_embed = false"
                  type="button"
                  class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium"
                >
                  Close
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script lang="ts" setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import { XIcon } from "vue-tabler-icons";
import { useQrCreateStore } from "~~/stores/qrcreate";
const qrcreate = useQrCreateStore();
const datajd = useDataJd();

const html = computed(()=>{
    if (qrcreate.config.data) {
        return `<img src="https://chart.googleapis.com/chart?cht=qr&chl=${encodeURIComponent(qrcreate.config.data)}&chs=180x180&choe=UTF-8&chld=L|2" rel="nofollow" alt="qr code"><a href="${datajd.currentHost()}" border="0" style="cursor:default" rel="nofollow"></a>`
    }
    return ''
})
</script>
